/**
 * Global Imports
*/

import { ChatUserstate } from 'tmi.js';

/**
 * Local Imports
*/

import { User } from '@system/User';

/**
 * Relative Imports
*/

import { ChatMessage, ChatEventHandler } from './types';

/**
 * Locals
*/

const events: Array<ChatEventHandler> = [];

/**
 * Public Functions
*/

/**
 * @param {User} user
 * @param {string} contents
 * @param {string} channel
 *
 * @return {ChatMessage}
 */
export function ChatMessageCreate(
    user: User,
    state: ChatUserstate,
    contents: string,
    isBot: boolean,
    channel?: string): ChatMessage
{
    return {
        user,
        contents,
        channel,
        isBot,
        emotes: state.emotes || {},
        sentAt: new Date(parseInt(state['tmi-sent-ts'])),
        isFirst: !!state['first-msg'],
    };
}

/**
 * @param {ChatEventHandler} handler
 *
 * @return {ChatMessage}
 */
export function ChatAddEventHandler(
    handler: ChatEventHandler): void
{
    events.push(handler);
}

/**
 * @param {User} user
 * @param {string} contents
 * @param {boolean} isBot
 * @param {string} channel
 *
 * @return {void}
 */
export function ChatDispatch(
    user: User,
    state: ChatUserstate,
    contents: string,
    isBot: boolean,
    channel?: string): void
{
    let message = ChatMessageCreate(user, state, contents, isBot, channel);
    let i = events.length;

    while (i--)
    {
        events[i](message);
    }
}
